var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.2.2.5-Queue-/-Register-patient----documents-available",
    transform: "translate(-983.000000, -84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(256.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Molecules/07.Input/04.Web/02.With-text/Default-Copy-9",
    transform: "translate(711.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "print",
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9807692,2.30769231 L2.09134615,2.30769231 C0.936327566,2.30769231 0,3.24401987 0,4.39903846 L0,10.0961538 C0,11.2113442 0.904040409,12.1153846 2.01923077,12.1153846 L2.30769231,12.1153846 L2.30769231,13.5461538 C2.30769231,14.3490909 2.9586014,15 3.76153846,15 L11.2384615,15 C12.0413986,15 12.6923077,14.3490909 12.6923077,13.5461538 L12.6923077,12.1153846 L12.9807692,12.1153846 C14.0959596,12.1153846 15,11.2113442 15,10.0961538 L15,4.32692308 C15,3.21173272 14.0959596,2.30769231 12.9807692,2.30769231 Z M11.5384615,13.5461538 C11.5378682,13.7115929 11.4039006,13.8455605 11.2384615,13.8461538 L3.76153846,13.8461538 C3.59609943,13.8455605 3.46213179,13.7115929 3.46153846,13.5461538 L3.46153846,7.8 C3.46213179,7.63456096 3.59609943,7.50059333 3.76153846,7.5 L11.2384615,7.5 C11.4039006,7.50059333 11.5378682,7.63456096 11.5384615,7.8 L11.5384615,13.5461538 Z M12.4759615,5.76634615 C12.1144406,5.79540414 11.7731533,5.59594426 11.6210368,5.26669921 C11.4689203,4.93745417 11.5382504,4.54828244 11.7947087,4.29182413 C12.0511671,4.03536582 12.4403388,3.9660357 12.7695838,4.11815219 C13.0988289,4.27026867 13.2982888,4.61155602 13.2692308,4.97307692 C13.2352135,5.39629749 12.8991821,5.73232893 12.4759615,5.76634615 L12.4759615,5.76634615 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6730769,0 L4.32692308,0 C3.3237613,0.00149378923 2.47329333,0.738095426 2.32860577,1.73076923 L12.6713942,1.73076923 C12.5267067,0.738095426 11.6762387,0.00149378923 10.6730769,0 Z",
    id: "Path"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.3f52786d.svg";
export { ForwardRef as ReactComponent };